import React, { useRef, useEffect } from "react";
import QRCode from 'react-qr-code';
import html2canvas from "html2canvas";
import styles from "./index.module.css";
import Stamp from "../../../../../assets/images/brand/Certificate Logo Gold.png";
import Seal from "../../../../../assets/images/brand/Seal-removebg-preview.png";
import IBSCLogo from "../../../../../assets/images/brand/IBSC.png";
import IBSULogo from "../../../../../assets/images/brand/IBSU.png";
import COELogo from "../../../../../assets/images/brand/COE.png";
import CDCLogo from "../../../../../assets/images/brand/CDC.png";
import RCCLogo from "../../../../../assets/images/brand/RC.png";
import NFFELogo from "../../../../../assets/images/brand/NFFE.png";

const QR_Link = process.env.REACT_APP_PUBLIC_QR_LINK;

const formatDateWithSuperscript = (dateString) => {
    if (!dateString) return '';

    const parts = dateString.split(' ');

    if (parts.length < 3) return dateString;

    let day = parts[0].match(/\d+/)[0];
    const suffix = parts[0].replace(/\d+/, '');
    const month = parts[1];
    const year = parts[2];

    day = day.padStart(2, '0');

    return { day, suffix, month, year };
};

const splitTextAndDate = (input = "") => {
    const text = normalizeInput(input);

    const dateRegex = /(\d{1,2})(st|nd|rd|th)\s+([A-Za-z]+)\s+(\d{4})/i;
    const match = text.match(dateRegex);

    if (!match) {
        return {
            prefixText: text,
            day: null,
            suffix: null,
            month: null,
            year: null,
        };
    }

    const [fullDate, day, suffix, month, year] = match;

    const prefixText = text.replace(fullDate, "").trim();

    return {
        prefixText,
        day,
        suffix,
        month,
        year,
    };
};

const normalizeInput = (text = "") => {
    return text
        .replace(/[\u0000-\u001F\u007F-\u009F]/g, "") // control chars
        .replace(/ᵗʰ/g, "th")
        .replace(/ˢᵗ/g, "st")
        .replace(/ⁿᵈ/g, "nd")
        .replace(/ʳᵈ/g, "rd")
        .trim();
};

const CDCCertificateImage = ({ data, onImageGenerated }) => {
    const certificateRef = useRef(null);
    const formattedDate = formatDateWithSuperscript(data?.completion_date);
    const formattedCertificateDate = formatDateWithSuperscript(data?.issued_date);

    const { prefixText, day, suffix, month, year } =
        splitTextAndDate(data?.completion_date);

    const templateTypeKey = `${data?.certificate_template?.name}_${data?.certificate_template?.certificate_type?.name}`
        .replace(/\s+/g, "_")
        .toUpperCase();

    const hasSecondSignature = data?.signature_name_2 && data?.signature_designation_2;
    useEffect(() => {
        const generateImage = async () => {
            if (!certificateRef.current) return;

            const canvas = await html2canvas(certificateRef.current, {
                scale: window.devicePixelRatio, // Capture at higher resolution
                useCORS: true, // Prevent cross-origin issues
                logging: false,
            });

            const imgData = canvas.toDataURL("image/jpeg", 1.0);

            // Send the generated image to the parent component
            if (onImageGenerated) {
                onImageGenerated(imgData);
            }
        };

        setTimeout(generateImage, 500); // Delay to ensure the component is fully rendered
    }, []);

    return (       
        <div ref={certificateRef} className={styles.certificateContainer} style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
            <img
                src={data?.certificate_template?.background_image}
                alt="Background"
                className={styles.backgroundImage}
                crossOrigin="anonymous"
            />

            {/* Content Layer */}
            <div className={styles.content}>
                <img src={data?.certificate_template?.header_logo} alt="Logo" className={styles.logo} crossOrigin="anonymous" />
                <p className={styles.textTitle}>{data?.certificate_phrase_1}</p>
                <p className={styles.text}>{data?.certificate_phrase_2}</p>
                <p className={styles.studentName}>{data?.student_name}</p>
                <p className={styles.textSentence}>
                    {data?.certificate_phrase_3}
                </p>
                <h3 className={styles.courseName}>{data?.other_course}</h3>
                <p className={styles.textSentence}>
                    {data?.conducted_by_phrase}
                </p>
                <p className={styles.textUni}>{data?.conducted_by}</p>
                <p className={styles.textSentence}>{data?.completion_phrase} {prefixText} {day}<span className={styles.superScript}>{suffix}</span> {month} {year}</p>
                {/* Footer with Signatures, Stamp, and QR */}
                <div className={styles.footer}>
                    <div className={styles.sealContainer}>
                        <img src={Seal} alt="Seal" className={styles.sealImg} crossOrigin="anonymous" />
                        {hasSecondSignature && (
                            <>
                                <p className={styles.signature}>{data?.signature_name_2}</p>
                                <p className={styles.signatureBottom}>{data?.signature_designation_2}</p>
                            </>)}
                        <p className={styles.signature}>{data?.signature_name_1}</p>
                        <p className={styles.signatureBottom}>{data?.signature_designation_1}</p>
                    </div>
                    <img src={data?.certificate_template?.footor_logo} alt="Stamp" className={styles.stamp} crossOrigin="anonymous" />
                    <div style={{ textAlign: "center" }}>
                        <QRCode
                            value={`${QR_Link}/document_ref/${data?.document_ref}`}
                            size={70}
                            className="code"
                        />
                        <p className={styles.qrText}>Scan to verify certificate.</p>
                        <p className={styles.detailsText}>Document Ref.: {data?.document_ref}</p>
                        <p className={styles.detailsText}>Issued Date: {formattedCertificateDate.day} {formattedCertificateDate.month} {formattedCertificateDate.year}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CDCCertificateImage;